import { IDexTrade, ITicker } from '@kattana-io/common';
import { Trade } from '../core/models/extended-trades.model';
import { TableTrade } from '../core/models/table-trade.model';

export enum TradesRequestType {
  appendStartTrades = 'append_start_trades',
  appendStartTradesWithReplace = 'append_start_trades_with_replace',
  appendEndTrades = 'append_end_trades',
  setTrades = 'set_trades',
}

export enum TradesType {
  trade = 'trade',
  tableTrade = 'table_trade',
}

type ShortTrade = {
  amount0: number;
  amount1: number;
  buy?: true;
  order: number;
  uuid: string;
};

export type TradesByBlock = Record<string, ShortTrade[]>;
export type TradesNumByWallet = Record<string, number>;

export type TradesRequestData =
  | {
      ticker: ITicker;
      trades: TableTrade[];
      hashedData: {
        byWallet: TradesNumByWallet;
        byBlock: TradesByBlock;
      };
      tradesToAppend: IDexTrade[];
      type:
        | TradesRequestType.appendStartTrades
        | TradesRequestType.appendStartTradesWithReplace;
    }
  | {
      ticker: ITicker;
      trades: TableTrade[];
      hashedData: {
        byWallet: TradesNumByWallet;
        byBlock: TradesByBlock;
      };
      tradesToAppend: Trade[];
      type: TradesRequestType.appendEndTrades;
    }
  | {
      ticker: ITicker;
      trades: Trade[];
      tradesType: TradesType.trade;
      type: TradesRequestType.setTrades;
    }
  | {
      ticker: ITicker;
      trades: TableTrade[];
      tradesType: TradesType.tableTrade;
      type: TradesRequestType.setTrades;
    };

export type TradesResponseData = {
  trades: TableTrade[];
  loading: boolean;
  hashedData: {
    byWallet: TradesNumByWallet;
    byBlock: TradesByBlock;
  };
};

export type TradesRef = {
  trades: TableTrade[];
  hashedData: {
    byWallet: TradesNumByWallet;
    byBlock: TradesByBlock;
  };
};
